import React from 'react';

import Image, { Props as ImageProps } from '@smart-tv/components/image/image';

import styles from './content-item.module.scss';

interface Props extends ImageProps {}

export const ContentItemLogo: React.FC<Props> = (props: Props) => {
  return (
    <div className={styles['logo-container']}>
      <div className={styles['logo-wrapper']}>
        <Image {...props} className={styles['logo']} />
      </div>
    </div>
  );
};

export default React.memo(ContentItemLogo);
